import { Button } from "@/components/ui/primitives";

/**
 * The three states every list page shares, so no page invents its own
 * spinner-or-empty-or-error layout.
 */
export function DataState({
  isLoading,
  isError,
  isEmpty,
  onRetry,
  children,
}: {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  onRetry?: () => void;
  children: React.ReactNode;
}) {
  if (isLoading) {
    return <p className="py-12 text-center text-sm text-muted-foreground">Yükleniyor…</p>;
  }

  if (isError) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-destructive">Bir sorun oluştu</p>
        {onRetry && (
          <Button variant="secondary" size="sm" className="mt-3" onClick={onRetry}>
            Tekrar dene
          </Button>
        )}
      </div>
    );
  }

  if (isEmpty) {
    return <p className="py-12 text-center text-sm text-muted-foreground">Kayıt yok</p>;
  }

  return <>{children}</>;
}
